import { keys as headerKeys, values as headerValues } from './headers';
import { Region } from './keys';
import { request } from './request';
import { geo as geoUrl } from './urls';

const regions = new Map([
  ['AD', 'EMEA'],
  ['AE', 'JAPAC'],
  ['AF', 'JAPAC'],
  ['AG', 'Americas'],
  ['AI', 'Americas'],
  ['AL', 'EMEA'],
  ['AM', 'JAPAC'],
  ['AN', 'Americas'],
  ['AO', 'EMEA'],
  ['AP', 'JAPAC'],
  ['AQ', 'Americas'],
  ['AR', 'Americas'],
  ['AS', 'JAPAC'],
  ['AT', 'EMEA'],
  ['AU', 'JAPAC'],
  ['AW', 'Americas'],
  ['AX', 'EMEA'],
  ['AZ', 'JAPAC'],
  ['BA', 'EMEA'],
  ['BB', 'Americas'],
  ['BD', 'JAPAC'],
  ['BE', 'EMEA'],
  ['BF', 'EMEA'],
  ['BG', 'EMEA'],
  ['BH', 'JAPAC'],
  ['BI', 'EMEA'],
  ['BJ', 'EMEA'],
  ['BL', 'Americas'],
  ['BM', 'Americas'],
  ['BN', 'JAPAC'],
  ['BO', 'Americas'],
  ['BR', 'Americas'],
  ['BS', 'Americas'],
  ['BT', 'JAPAC'],
  ['BV', 'Americas'],
  ['BW', 'EMEA'],
  ['BY', 'EMEA'],
  ['BZ', 'Americas'],
  ['CA', 'Americas'],
  ['CC', 'JAPAC'],
  ['CD', 'EMEA'],
  ['CF', 'EMEA'],
  ['CG', 'EMEA'],
  ['CH', 'EMEA'],
  ['CI', 'EMEA'],
  ['CK', 'JAPAC'],
  ['CL', 'Americas'],
  ['CM', 'EMEA'],
  ['CN', 'JAPAC'],
  ['CO', 'Americas'],
  ['CR', 'Americas'],
  ['CU', 'Americas'],
  ['CV', 'EMEA'],
  ['CX', 'JAPAC'],
  ['CY', 'JAPAC'],
  ['CZ', 'EMEA'],
  ['DE', 'EMEA'],
  ['DJ', 'EMEA'],
  ['DK', 'EMEA'],
  ['DM', 'Americas'],
  ['DO', 'Americas'],
  ['DZ', 'EMEA'],
  ['EC', 'Americas'],
  ['EE', 'EMEA'],
  ['EG', 'EMEA'],
  ['EH', 'EMEA'],
  ['ER', 'EMEA'],
  ['ES', 'EMEA'],
  ['ET', 'EMEA'],
  ['EU', 'EMEA'],
  ['FI', 'EMEA'],
  ['FJ', 'JAPAC'],
  ['FK', 'Americas'],
  ['FM', 'JAPAC'],
  ['FO', 'EMEA'],
  ['FR', 'EMEA'],
  ['FX', 'EMEA'],
  ['GA', 'EMEA'],
  ['GB', 'EMEA'],
  ['GD', 'Americas'],
  ['GE', 'JAPAC'],
  ['GF', 'Americas'],
  ['GG', 'EMEA'],
  ['GH', 'EMEA'],
  ['GI', 'EMEA'],
  ['GL', 'Americas'],
  ['GM', 'EMEA'],
  ['GN', 'EMEA'],
  ['GP', 'Americas'],
  ['GQ', 'EMEA'],
  ['GR', 'EMEA'],
  ['GS', 'Americas'],
  ['GT', 'Americas'],
  ['GU', 'JAPAC'],
  ['GW', 'EMEA'],
  ['GY', 'Americas'],
  ['HK', 'JAPAC'],
  ['HM', 'Americas'],
  ['HN', 'Americas'],
  ['HR', 'EMEA'],
  ['HT', 'Americas'],
  ['HU', 'EMEA'],
  ['ID', 'JAPAC'],
  ['IE', 'EMEA'],
  ['IL', 'JAPAC'],
  ['IM', 'EMEA'],
  ['IN', 'JAPAC'],
  ['IO', 'JAPAC'],
  ['IQ', 'JAPAC'],
  ['IR', 'JAPAC'],
  ['IS', 'EMEA'],
  ['IT', 'EMEA'],
  ['JE', 'EMEA'],
  ['JM', 'Americas'],
  ['JO', 'JAPAC'],
  ['JP', 'JAPAC'],
  ['KE', 'EMEA'],
  ['KG', 'JAPAC'],
  ['KH', 'JAPAC'],
  ['KI', 'JAPAC'],
  ['KM', 'EMEA'],
  ['KN', 'Americas'],
  ['KP', 'JAPAC'],
  ['KR', 'JAPAC'],
  ['KW', 'JAPAC'],
  ['KY', 'Americas'],
  ['KZ', 'JAPAC'],
  ['LA', 'JAPAC'],
  ['LB', 'JAPAC'],
  ['LC', 'Americas'],
  ['LI', 'EMEA'],
  ['LK', 'JAPAC'],
  ['LR', 'EMEA'],
  ['LS', 'EMEA'],
  ['LT', 'EMEA'],
  ['LU', 'EMEA'],
  ['LV', 'EMEA'],
  ['LY', 'EMEA'],
  ['MA', 'EMEA'],
  ['MC', 'EMEA'],
  ['MD', 'EMEA'],
  ['ME', 'EMEA'],
  ['MF', 'Americas'],
  ['MG', 'EMEA'],
  ['MH', 'JAPAC'],
  ['MK', 'EMEA'],
  ['ML', 'EMEA'],
  ['MM', 'JAPAC'],
  ['MN', 'JAPAC'],
  ['MO', 'JAPAC'],
  ['MP', 'JAPAC'],
  ['MQ', 'Americas'],
  ['MR', 'EMEA'],
  ['MS', 'Americas'],
  ['MT', 'EMEA'],
  ['MU', 'EMEA'],
  ['MV', 'JAPAC'],
  ['MW', 'EMEA'],
  ['MX', 'Americas'],
  ['MY', 'JAPAC'],
  ['MZ', 'EMEA'],
  ['NA', 'EMEA'],
  ['NC', 'JAPAC'],
  ['NE', 'EMEA'],
  ['NF', 'JAPAC'],
  ['NG', 'EMEA'],
  ['NI', 'Americas'],
  ['NL', 'EMEA'],
  ['NO', 'EMEA'],
  ['NP', 'JAPAC'],
  ['NR', 'JAPAC'],
  ['NU', 'JAPAC'],
  ['NZ', 'JAPAC'],
  ['OM', 'JAPAC'],
  ['PA', 'Americas'],
  ['PE', 'Americas'],
  ['PF', 'JAPAC'],
  ['PG', 'JAPAC'],
  ['PH', 'JAPAC'],
  ['PK', 'JAPAC'],
  ['PL', 'EMEA'],
  ['PM', 'Americas'],
  ['PN', 'JAPAC'],
  ['PR', 'Americas'],
  ['PS', 'JAPAC'],
  ['PT', 'EMEA'],
  ['PW', 'JAPAC'],
  ['PY', 'Americas'],
  ['QA', 'JAPAC'],
  ['RE', 'EMEA'],
  ['RO', 'EMEA'],
  ['RS', 'EMEA'],
  ['RU', 'EMEA'],
  ['RW', 'EMEA'],
  ['SA', 'JAPAC'],
  ['SB', 'JAPAC'],
  ['SC', 'EMEA'],
  ['SD', 'EMEA'],
  ['SE', 'EMEA'],
  ['SG', 'JAPAC'],
  ['SH', 'EMEA'],
  ['SI', 'EMEA'],
  ['SJ', 'EMEA'],
  ['SK', 'EMEA'],
  ['SL', 'EMEA'],
  ['SM', 'EMEA'],
  ['SN', 'EMEA'],
  ['SO', 'EMEA'],
  ['SR', 'Americas'],
  ['ST', 'EMEA'],
  ['SV', 'Americas'],
  ['SY', 'JAPAC'],
  ['SZ', 'EMEA'],
  ['TC', 'Americas'],
  ['TD', 'EMEA'],
  ['TF', 'Americas'],
  ['TG', 'EMEA'],
  ['TH', 'JAPAC'],
  ['TJ', 'JAPAC'],
  ['TK', 'JAPAC'],
  ['TL', 'JAPAC'],
  ['TM', 'JAPAC'],
  ['TN', 'EMEA'],
  ['TO', 'JAPAC'],
  ['TR', 'EMEA'],
  ['TT', 'Americas'],
  ['TV', 'JAPAC'],
  ['TW', 'JAPAC'],
  ['TZ', 'EMEA'],
  ['UA', 'EMEA'],
  ['UG', 'EMEA'],
  ['UM', 'JAPAC'],
  ['US', 'Americas'],
  ['UY', 'Americas'],
  ['UZ', 'JAPAC'],
  ['VA', 'EMEA'],
  ['VC', 'Americas'],
  ['VE', 'Americas'],
  ['VG', 'Americas'],
  ['VI', 'Americas'],
  ['VN', 'JAPAC'],
  ['VU', 'JAPAC'],
  ['WF', 'JAPAC'],
  ['WS', 'JAPAC'],
  ['YE', 'JAPAC'],
  ['YT', 'EMEA'],
  ['ZA', 'EMEA'],
  ['ZM', 'EMEA'],
  ['ZW', 'EMEA'],
]);

export async function region(code = '') {
  let result = sessionStorage.getItem(Region) || void 0;

  if (result === void 0) {
    try {
      const res = await request(geoUrl, { headers: { [headerKeys.accept]: [headerValues.json] } });

      if (res.ok) {
        const data = await res.json();

        if (data.data !== null && 'country' in data.data && data.data.country.iso_code !== code) {
          result = data.data.country.iso_code || '';
        }
      }
    } catch (err) {
      void 0;
    }
  }

  if (result === void 0 && code.length > 0) {
    result = code;
  }

  if (result !== void 0 && result.length > 0) {
    // Reducing to a Region
    if (regions.has(result)) {
      result = regions.get(result);
    }

    sessionStorage.setItem(Region, result);
  }

  return result;
}
